import { LoadingAction, UIDataType, UIData } from "./types";

export const initialState: UIData = {
  loading: false,
  openingAccountsLookup: false,
  refreshHomePageData: true,
};

const UIReducer = (state = initialState, { type }: LoadingAction) => {
  switch (type) {
    case UIDataType.START_LOADING:
      return {
        ...state,
        loading: true,
      };
    case UIDataType.STOP_LOADING:
      return {
        ...state,
        loading: false,
      };
    case UIDataType.START_OPEN_ACCOUNTS_LOOKUP:
      return {
        ...state,
        openingAccountsLookup: true,
      };
    case UIDataType.STOP_OPEN_ACCOUNTS_LOOKUP:
      return {
        ...state,
        openingAccountsLookup: false,
      };
    case UIDataType.REFRESH_HOME_PAGE_DATA:
      const refresh = !state.refreshHomePageData;

      return {
        ...state,
        refreshHomePageData: refresh,
      };
    default:
      return state;
  }
};
export default UIReducer;
